import styled from 'styled-components'

export const LinkButton = styled.button`
  background: transparent;
  border: none;
  font-weight: bold;
  outline: none;
  transition: all 0.5s ease;
`
